// ============================================
// ProtractionSettingsMenu.jsx - settings for the Protraction overlay
// (protraction-20261018). Shared shell (menu/ChartMenu). Applies
// immediately. RESET restores PROTRACTION_DEFAULTS, leaves on/off alone.
// ============================================
import ChartMenu, { MenuRow, MenuNumber, MenuSwatch, MenuToggle, MenuDivider, MenuActions, MenuButton } from './menu/ChartMenu'
import { PROTRACTION_DEFAULTS } from '../utils/protraction'

export default function ProtractionSettingsMenu({ show, x, y, openLeft, enabled, onToggle, config, onUpdate, onClose }) {
  if (!show || !config) return null
  const c = config
  const set = (k) => (v) => onUpdate({ [k]: v })
  return (
    <ChartMenu anchor={{ x, y }} openLeft={openLeft} onClose={onClose} title="Protraction">
      <MenuRow label="Protraction">
        <MenuToggle on={!!enabled} onChange={(v) => onToggle(v)} title="Show / hide the protraction leg (open to wick extreme) in each candle">
          {enabled ? 'ON' : 'OFF'}
        </MenuToggle>
        <MenuDivider />
        <MenuToggle on={c.dots} onChange={set('dots')} title="Dot at the protraction extreme">
          Dot
        </MenuToggle>
      </MenuRow>
      <MenuRow>
        <MenuSwatch label="COLOR" value={c.color} onChange={set('color')} />
        <MenuDivider />
        <MenuNumber label="OPACITY" value={c.opacity} float step={0.05} min={0} max={1} width={44}
          title="Line opacity (0-1)" onCommit={set('opacity')} />
      </MenuRow>
      <MenuActions>
        <MenuButton variant="ghost" style={{ flex: 1 }} onClick={() => onUpdate({ ...PROTRACTION_DEFAULTS })}>RESET</MenuButton>
        <MenuButton variant="primary" onClick={onClose}>CLOSE</MenuButton>
      </MenuActions>
    </ChartMenu>
  )
}
